export const stepConfig = {
    subscriptionUpgrade: {
        title: "Please confirm you wish to purchase this upgrade",
        subtitle: "Billed annually in advance"
    },
    discountCode: {
        title: "Do you have a discount code?",
        subtitle: "Your Advisor or Investor may have provided you with a discount code"
    },
    freeMembership: {
        title: "You have selected a FREE subscription",
        subtitle: "(and that's great, thanks)"
    },
    modulePurchase: {
        title: "Please confirm you wish to purchase this module",
        subtitle: "This is a one-time purchase, not an annual charge."
    },
    tempModulePurchase: {
        title: "Please confirm you wish to purchase this module",
        subtitle: "This is a one-time purchase, not an annual charge."
    },
    freeModule: {
        title: "Please confirm you wish to start using this module",
    }
}; 